import type { ModuleRouteNames } from '../moduleRouteNames'
import type { RvaiRouteRecord } from '../types'
import { routes as aboutRoutes } from './about'
import { routes as camerasRoutes } from './cameras'
import { routes as classesRoutes } from './classes'
import { routes as inferenceMonitoringRoutes } from './inferences'
import { routes as membersRoutes } from './members'
import { routes as pluginsRoutes } from './plugins'
import { routes as projectsRoutes } from './projects'
import { routes as resourcesRoutes } from './resources'
import { routes as settingsRoutes } from './settings'


export const moduleRoutes: RvaiRouteRecord<ModuleRouteNames>[] = [
  aboutRoutes,
  camerasRoutes,
  classesRoutes,
  // datapoolsRoutes,
  inferenceMonitoringRoutes,
  membersRoutes,
  // modelsRoutes,
  pluginsRoutes,
  projectsRoutes,
  resourcesRoutes,
  settingsRoutes,
]
